const LinkIcon = () => {
  return (
    <svg height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M 14.6 3.4 C 14.1 2.8 13.3 2.5 12.5 2.5 C 11.7 2.5 10.9 2.8 10.4 3.4 L 11.1 4.1 C 11.6 3.6 12.3 3.4 13 3.6 C 13.7 3.8 14.3 4.3 14.4 5 C 14.6 5.7 14.4 6.4 13.9 6.9 L 9.9 10.9 C 9.4 11.4 8.7 11.6 8 11.4 C 7.3 11.3 6.8 10.7 6.6 10 C 6.4 9.3 6.6 8.6 7.1 8.1 L 7.8 7.4 L 7.1 6.7 L 6.4 7.4 C 5.8 7.9 5.5 8.7 5.5 9.5 C 5.5 10.3 5.8 11.1 6.4 11.6 C 6.9 12.2 7.7 12.5 8.5 12.5 C 9.3 12.5 10.1 12.2 10.6 11.6 L 14.6 7.6 C 15.8 6.4 15.8 4.5 14.6 3.4 Z M 2.1 12.4 C 1.7 12 1.5 11.5 1.5 11 C 1.5 10.5 1.7 10 2.1 9.6 L 6.1 5.6 C 6.5 5.2 7 5 7.5 5 C 8 5 8.6 5.2 8.9 5.6 C 9.3 6 9.5 6.5 9.5 7 C 9.5 7.5 9.3 8 8.9 8.4 L 7.9 9.5 L 8.6 10.2 L 9.6 9.2 C 10.8 8 10.8 6.1 9.6 4.9 C 8.5 3.7 6.5 3.7 5.4 4.9 L 1.4 8.9 C 0.8 9.5 0.5 10.2 0.5 11 C 0.5 11.8 0.8 12.6 1.4 13.2 C 1.9 13.7 2.7 14 3.5 14 C 4.3 14 5.1 13.7 5.6 13.1 L 4.9 12.4 C 4.6 12.8 4 13 3.5 13 C 3 13 2.5 12.8 2.1 12.4 Z'
        fillRule='evenodd'
        stroke='none'
      />
    </svg>
  );
};

export default LinkIcon;
